const STALE_CLIENT_ERROR_PATTERNS = [
  /error loading dynamically imported module/i,
  /failed to fetch dynamically imported module/i,
  /importing a module script failed/i,
  /chunkloaderror/i,
  /loading chunk [\w-]+ failed/i,
  /loading css chunk [\w-]+ failed/i,
];

function getErrorTextCandidates(error: unknown): string[] {
  if (!error) {
    return [];
  }

  if (typeof error === "string") {
    return [error];
  }

  if (error instanceof Error) {
    return [error.name, error.message, error.stack ?? ""];
  }

  if (typeof error === "object") {
    const candidate = error as {
      message?: unknown;
      name?: unknown;
      reason?: unknown;
      stack?: unknown;
    };

    return [
      candidate.name,
      candidate.message,
      candidate.reason,
      candidate.stack,
    ].filter((value): value is string => typeof value === "string");
  }

  return [];
}

export function isLikelyStaleClientError(error: unknown) {
  return getErrorTextCandidates(error).some((value) =>
    STALE_CLIENT_ERROR_PATTERNS.some((pattern) => pattern.test(value)),
  );
}
